import { useState } from 'react'
import GerarDocumento from './pages/GerarDocumento'
import CadastrarVeiculo from './pages/CadastrarVeiculo'
import CadastrarCliente from './pages/CadastrarCliente'
import ListaContratos from './pages/ListaContratos'
import Usuarios from './pages/Usuarios'
import Logs from './pages/Logs'
import Login from './pages/Login'
import { getCurrentUser } from './services/auth'
import { api } from './services/api'

const ALL_PAGES = {
  documentos: { label: 'Gerar Documento', component: GerarDocumento,  minRole: 'basico' },
  clientes:   { label: 'Clientes',        component: CadastrarCliente, minRole: 'intermediario' },
  veiculos:   { label: 'Veículos',        component: CadastrarVeiculo, minRole: 'master' },
  contratos:  { label: 'Histórico',       component: ListaContratos,   minRole: 'intermediario' },
  usuarios:   { label: 'Usuários',        component: Usuarios,         minRole: 'master' },
  logs:       { label: 'Log',             component: Logs,             minRole: 'master' },
}

const ROLE_ORDER = { basico: 0, intermediario: 1, master: 2 }

const GLOBAL_STYLES = `
  :root, .light {
    --bg: #EBEBEB;
    --card-bg: #FAFAF8;
    --card-border: #E2D9C8;
    --text-primary: #2A2218;
    --text-secondary: #9A8E7A;
    --border: #D5CDB8;
    --section-border: #EDE5D5;
    --input-bg: #FAFAF8;
    --input-text: #1A1A1A;
    --nav-bg: #1C1C1C;
    --nav-border: #2E2A20;
    --btn-bg: #FAFAF8;
    --btn-text: #3A3020;
    --btn-border: #D5CDB8;
    --active-bg: #F5EDD5;
    --active-border: #C9A84C;
    --shadow: rgba(0,0,0,0.07);
  }
  .dark {
    --bg: #111111;
    --card-bg: #141414;
    --card-border: #1E1E1E;
    --text-primary: #E8E0D0;
    --text-secondary: #9A8E7E;
    --border: #2A2218;
    --section-border: #1E1A12;
    --input-bg: #1A1A1A;
    --input-text: #E8E0D0;
    --nav-bg: #0A0A0A;
    --nav-border: #1E1A10;
    --btn-bg: #1A1A1A;
    --btn-text: #C8C0B0;
    --btn-border: #2A2218;
    --active-bg: #2A2010;
    --active-border: #C9A84C;
    --shadow: rgba(0,0,0,0.5);
  }
  html, body { margin: 0; padding: 0; }
  .light { color: var(--text-primary); }
  .dark  { color: var(--text-primary); }
  .dark, .dark body { background: #111111; }
  .dark .card {
    background: #111111 !important;
    border-color: #1C1C1C !important;
  }
  * { box-sizing: border-box; }
  input, select, textarea {
    border: 1.5px solid var(--border) !important;
    border-radius: 14px !important;
    padding: 10px 14px !important;
    font-size: 14px !important;
    background: var(--input-bg) !important;
    color: var(--input-text) !important;
    outline: none !important;
    transition: border-color 0.2s, box-shadow 0.2s !important;
    font-family: Georgia, serif !important;
    width: 100% !important;
  }
  input:focus, select:focus {
    border-color: #C9A84C !important;
    box-shadow: 0 0 0 3px rgba(201,168,76,0.18) !important;
  }
  button {
    border: 1.5px solid var(--btn-border);
    border-radius: 14px;
    padding: 9px 18px;
    font-size: 13px;
    cursor: pointer;
    background: var(--btn-bg);
    color: var(--btn-text);
    font-family: Georgia, serif;
    transition: all 0.2s;
    letter-spacing: 0.03em;
  }
  button:hover { border-color: var(--active-border); background: var(--active-bg); }
  .card {
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    border-radius: 22px;
    padding: 1.5rem 1.75rem;
    margin-bottom: 1.25rem;
  }
  .card h2 {
    font-size: 11px;
    font-weight: normal;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #C9A84C;
    margin: 0 0 1.1rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid var(--section-border);
  }
  .field { display: flex; flex-direction: column; gap: 5px; }
  .field label {
    font-size: 11px !important;
    letter-spacing: 0.10em;
    text-transform: uppercase;
    color: var(--text-secondary) !important;
  }
  .badge-ok {
    background: #F2FAF2; border: 1px solid #BCDCBC;
    border-radius: 12px; padding: 10px 14px;
    font-size: 13px; color: #2A6A2A; margin-top: 8px;
  }
  .dark .badge-ok {
    background: #102010; border-color: #204020; color: #70BA70;
  }
  .badge-err {
    background: #FAF2F2; border: 1px solid #DCBCBC;
    border-radius: 12px; padding: 10px 14px;
    font-size: 13px; color: #7A2A2A; margin-top: 8px;
  }
  .dark .badge-err {
    background: #201010; border-color: #402020; color: #BA7070;
  }
  .btn-gold {
    background: linear-gradient(135deg, #C9A84C 0%, #A8832A 100%) !important;
    border: none !important; color: white !important;
    font-size: 14px !important; letter-spacing: 0.08em !important;
    padding: 13px 24px !important; border-radius: 14px !important;
    box-shadow: 0 2px 10px rgba(180,140,40,0.28) !important;
    cursor: pointer !important; width: 100% !important;
    font-family: Georgia, serif !important;
  }
  .btn-gold:hover { box-shadow: 0 4px 18px rgba(180,140,40,0.4) !important; }
  .btn-gold:disabled { opacity: 0.6 !important; cursor: wait !important; }
  table { width: 100%; border-collapse: collapse; font-size: 14px; }
  th {
    text-align: left; padding: 8px 6px; font-weight: normal;
    font-size: 11px; letter-spacing: 0.10em; text-transform: uppercase;
    color: var(--text-secondary); border-bottom: 1px solid var(--section-border);
  }
  td { padding: 11px 6px; border-bottom: 1px solid var(--border); color: var(--text-primary); }

  /* Status badges e selects */
  .sb { font-size: 12px; padding: 3px 10px; border-radius: 10px; }
  .s-gerado    { background: #F5F0E8; color: #7A6840; }
  .s-assinado  { background: #E8F0FA; color: #2A4A7A; }
  .s-ativo     { background: #E8FAF0; color: #2A6A40; }
  .s-encerrado { background: #F0F0F0; color: #606060; }
  .s-cancelado { background: #FAE8E8; color: #7A2A2A; }
  .dark .s-gerado    { background: #2A2010; color: #C9A070; }
  .dark .s-assinado  { background: #101830; color: #7090CA; }
  .dark .s-ativo     { background: #102010; color: #70BA70; }
  .dark .s-encerrado { background: #1A1A1A; color: #909090; }
  .dark .s-cancelado { background: #200808; color: #BA7070; }
  select.s-gerado    { background: #F5F0E8 !important; color: #7A6840 !important; border: none !important; cursor: pointer; width: auto !important; }
  select.s-assinado  { background: #E8F0FA !important; color: #2A4A7A !important; border: none !important; cursor: pointer; width: auto !important; }
  select.s-ativo     { background: #E8FAF0 !important; color: #2A6A40 !important; border: none !important; cursor: pointer; width: auto !important; }
  select.s-encerrado { background: #F0F0F0 !important; color: #606060 !important; border: none !important; cursor: pointer; width: auto !important; }
  select.s-cancelado { background: #FAE8E8 !important; color: #7A2A2A !important; border: none !important; cursor: pointer; width: auto !important; }
  .dark select.s-gerado    { background: #2A2010 !important; color: #C9A070 !important; }
  .dark select.s-assinado  { background: #101830 !important; color: #7090CA !important; }
  .dark select.s-ativo     { background: #102010 !important; color: #70BA70 !important; }
  .dark select.s-encerrado { background: #1A1A1A !important; color: #909090 !important; }
  .dark select.s-cancelado { background: #200808 !important; color: #BA7070 !important; }

  /* Role badges */
  .r-basico        { background: #F0F0F0; color: #606060; }
  .r-intermediario { background: #E8F0FA; color: #2A4A7A; }
  .r-master        { background: #F5F0E8; color: #7A6840; }
  .dark .r-basico        { background: #1A1A1A; color: #909090; }
  .dark .r-intermediario { background: #101830; color: #7090CA; }
  .dark .r-master        { background: #2A2010; color: #C9A070; }

  /* Ativo / inativo */
  .s-ativo-badge  { background: #E8FAF0; color: #2A6A40; }
  .s-inativo-badge{ background: #F0F0F0; color: #606060; }
  .dark .s-ativo-badge  { background: #102010; color: #70BA70; }
  .dark .s-inativo-badge{ background: #1A1A1A; color: #909090; }

  /* Botões de ação temáticos */
  .btn-green { color: #2A6A2A !important; border-color: #90C090 !important; }
  .dark .btn-green { color: #70BA70 !important; border-color: #2A5A2A !important; }
  .btn-amber { color: #7A5A10 !important; border-color: #C9A84C !important; }
  .dark .btn-amber { color: #C9A84C !important; border-color: #5A4010 !important; }
  .btn-danger-outline { color: #7A2A2A !important; border-color: #DCBCBC !important; }
  .dark .btn-danger-outline { color: #BA7070 !important; border-color: #5A2020 !important; }

  /* Texto de perigo (títulos de modal de exclusão etc.) */
  .text-danger { color: #7A2A2A; }
  .dark .text-danger { color: #BA7070; }
`

function ModalAlterarSenha({ onFechar }) {
  const [form, setForm] = useState({ atual: '', nova: '', confirmar: '' })
  const [salvando, setSalvando] = useState(false)
  const [erro, setErro] = useState('')
  const [sucesso, setSucesso] = useState(false)
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }))

  const salvar = async () => {
    setErro('')
    if (!form.atual || !form.nova || !form.confirmar)
      return setErro('Preencha todos os campos.')
    if (form.nova !== form.confirmar)
      return setErro('A nova senha e a confirmação não coincidem.')
    if (form.nova.length < 6)
      return setErro('A nova senha deve ter ao menos 6 caracteres.')
    setSalvando(true)
    try {
      await api.usuarios.alterarSenha(form.atual, form.nova)
      setSucesso(true)
      setTimeout(onFechar, 1800)
    } catch (e) {
      setErro(e.message)
    } finally {
      setSalvando(false)
    }
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: '1rem' }}>
      <div style={{ background: 'var(--card-bg)', borderRadius: '22px', border: '1px solid var(--card-border)', padding: '2rem', width: '100%', maxWidth: '400px', boxShadow: '0 8px 40px rgba(0,0,0,0.4)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
          <h2 style={{ margin: 0, border: 'none', padding: 0, color: '#C9A84C', fontSize: '13px', letterSpacing: '0.12em', textTransform: 'uppercase' }}>Alterar Senha</h2>
          <button onClick={onFechar} style={{ padding: '5px 12px', fontSize: '12px' }}>Cancelar</button>
        </div>
        {sucesso ? (
          <div className="badge-ok">Senha alterada com sucesso!</div>
        ) : (
          <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div className="field">
                <label>Senha atual</label>
                <input type="password" value={form.atual} onChange={set('atual')} autoFocus />
              </div>
              <div className="field">
                <label>Nova senha</label>
                <input type="password" value={form.nova} onChange={set('nova')} />
              </div>
              <div className="field">
                <label>Confirmar nova senha</label>
                <input type="password" value={form.confirmar} onChange={set('confirmar')}
                  onKeyDown={e => e.key === 'Enter' && salvar()} />
              </div>
            </div>
            {erro && <div className="badge-err" style={{ marginTop: '12px' }}>{erro}</div>}
            <button className="btn-gold" onClick={salvar} disabled={salvando} style={{ marginTop: '1.25rem' }}>
              {salvando ? 'SALVANDO...' : 'SALVAR NOVA SENHA'}
            </button>
          </>
        )}
      </div>
    </div>
  )
}

export default function App() {
  const [autenticado, setAutenticado] = useState(!!localStorage.getItem('zf_token'))
  const [page, setPage] = useState('documentos')
  const [darkMode, setDarkMode] = useState(localStorage.getItem('zf_theme') === 'dark')
  const [modalSenha, setModalSenha] = useState(false)

  const toggleTheme = () => {
    const novo = !darkMode
    setDarkMode(novo)
    localStorage.setItem('zf_theme', novo ? 'dark' : 'light')
    document.body.style.background = novo ? '#111111' : '#EBEBEB'
  }

  // Sincroniza o background do body na montagem
  useState(() => {
    document.body.style.background = darkMode ? '#111111' : '#EBEBEB'
  })

  const themeClass = darkMode ? 'dark' : 'light'

  if (!autenticado) {
    return (
      <div className={themeClass} style={{ minHeight: '100vh', background: 'var(--bg)', fontFamily: 'Georgia, serif' }}>
        <style>{GLOBAL_STYLES}</style>
        <Login onLogin={() => setAutenticado(true)} onToggleTheme={toggleTheme} darkMode={darkMode} />
      </div>
    )
  }

  const user = getCurrentUser()
  const userRoleOrder = ROLE_ORDER[user?.role] ?? 0
  const pagesVisiveis = Object.entries(ALL_PAGES).filter(
    ([, { minRole }]) => userRoleOrder >= (ROLE_ORDER[minRole] ?? 0)
  )
  const pageAtual = pagesVisiveis.find(([k]) => k === page) ? page : 'documentos'
  const Page = ALL_PAGES[pageAtual].component

  const sair = () => {
    localStorage.removeItem('zf_token')
    setAutenticado(false)
  }

  return (
    <div className={themeClass} style={{ minHeight: '100vh', background: 'var(--bg)', fontFamily: 'Georgia, serif' }}>
      <style>{GLOBAL_STYLES}</style>

      <nav style={{
        background: 'var(--nav-bg)', borderBottom: '1px solid var(--nav-border)',
        padding: '0 2rem', display: 'flex', alignItems: 'center', height: '60px',
      }}>
        <img src="/Logo.webp" alt="ZF Locadora" style={{ height: '44px', marginRight: '2.5rem', objectFit: 'contain' }} />

        {pagesVisiveis.map(([key, { label }]) => (
          <button key={key} onClick={() => setPage(key)} style={{
            background: 'none', border: 'none',
            borderBottom: pageAtual === key ? '2px solid #C9A84C' : '2px solid transparent',
            borderRadius: 0, padding: '0 1rem', height: '60px',
            fontSize: '12px', cursor: 'pointer', letterSpacing: '0.08em',
            color: pageAtual === key ? '#E2C97E' : '#777',
            fontWeight: pageAtual === key ? 'bold' : 'normal',
            transition: 'color 0.2s',
          }}>
            {label.toUpperCase()}
          </button>
        ))}

        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          {user && (
            <span style={{ fontSize: '12px', color: '#888', letterSpacing: '0.04em' }}>
              {user.nome}
              <span style={{ marginLeft: '6px', fontSize: '10px', padding: '2px 7px', borderRadius: '8px', background: '#2E2A20', color: '#C9A84C', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                {user.role}
              </span>
            </span>
          )}
          <button onClick={() => setModalSenha(true)} style={{
            background: 'none', border: '1px solid #444', borderRadius: '20px',
            padding: '4px 12px', fontSize: '11px', color: '#888',
            letterSpacing: '0.06em', cursor: 'pointer', transition: 'all 0.2s',
          }}>
            SENHA
          </button>
          <button onClick={toggleTheme} style={{
            background: 'none', border: '1px solid #444', borderRadius: '20px',
            padding: '4px 12px', fontSize: '11px', color: '#888',
            letterSpacing: '0.06em', cursor: 'pointer', transition: 'all 0.2s',
          }}>
            {darkMode ? 'CLARO' : 'ESCURO'}
          </button>
          <button onClick={sair} style={{
            background: 'none', border: 'none', borderRadius: 0,
            padding: '0 0.25rem', height: '60px', fontSize: '12px',
            cursor: 'pointer', letterSpacing: '0.08em', color: '#555',
          }}>
            SAIR
          </button>
        </div>
      </nav>

      <main style={{ maxWidth: '960px', margin: '0 auto', padding: '2rem 1.5rem' }}>
        <Page />
      </main>

      {modalSenha && <ModalAlterarSenha onFechar={() => setModalSenha(false)} />}
    </div>
  )
}
